import { observer } from "mobx-react";
import "./onboarding-plan-card-layout.scss";
import { RadioButton } from "../../../../../components/inputs/radio-button/radio-button";

interface IProps {
    children: React.ReactChild | React.ReactNode;
    radioButtonName: string;
    isChecked?: boolean;
    onChange?: () => void;
    tagBackground?: string;
    tagTitle?: string;
}

const OnboardingPlanCardLayout: React.FC<IProps> = observer(({ children, radioButtonName, isChecked, onChange, tagBackground, tagTitle }:IProps) => {

    return (
        <div className={`onboarding-plan-card-layout ${isChecked ? 'selected' : ''}`} onClick={onChange}>
            <div className="onboarding-plan-card-radio-button">
                <RadioButton 
                    name={radioButtonName}
                    checked={isChecked}
                />
            </div>
            {children}
        </div>
    );
});

export default OnboardingPlanCardLayout;